import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Page from 'app/components/misc/BasePage';
import PageHead from 'app/components/misc/PageHead';
import OpinionDetailContent from 'app/pageContents/OpinionDetailContent';
import dispatchWithPromise from 'app/utils/withPromise';
import { getCommentsRequest } from 'app/entity/comment/commentRedux';
import { configureOpinionDetailPageHead } from 'app/utils/configurePageHead';

// Dispatcher.
import { getOpinion } from 'app/dispatcher/opinionDispatcher';
import { useRouter } from 'next/router';

const OpinionDetail = ({ opinionSlug }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { rcid, pcid } = router.query;

  const opinionId = useSelector(state => state.opinion.ids[0]);
  const opinion = useSelector(state => state.opinion.byId[opinionId]);
  const isSignedIn = useSelector(state => state.auth.session.isSignedIn);

  useEffect(() => {
    if (isSignedIn) {
      dispatch(getOpinion({ opinionSlug }));
    }
  }, [dispatch, isSignedIn, opinionSlug]);

  useEffect(() => {
    dispatch(
      getCommentsRequest({
        commentableId: opinionId,
        commentableType: 'Opinion',
        page: 1,
        ...(pcid && { pcid }),
        ...(rcid && { rcid }),
      }),
    );
  }, []);

  return (
    <Page>
      <PageHead {...configureOpinionDetailPageHead(opinion)} />
      <OpinionDetailContent opinion={opinion} />
    </Page>
  );
};

OpinionDetail.getInitialProps = async ({ store, query }) => {
  const { dispatch } = store;

  const { opinionSlug } = query;

  await dispatchWithPromise(dispatch, getOpinion, { opinionSlug });

  return { opinionSlug };
};

export default OpinionDetail;
